import React from 'react'
import { AllUsersWithClaims } from '../../components/admin/AllUsersWithClaims'
export const Clients = () => { 
    return (
    <>
    
    <AllUsersWithClaims/>
    </>
    )
} 